var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container align-self-center"},[_c('h1',[_vm._v("Dev Portal")]),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.login}},[_vm._v("\n    Login\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }